import React, { FC } from 'react';
import './HowItWorksContent.css';

interface HowItWorksContentProps {
  content: string[]
}

const HowItWorksContent: FC<HowItWorksContentProps> = ({content}:HowItWorksContentProps) => {
  return (
    <div className="HowItWorksContent">
      <div className="header-text">How it Works</div>
      <ul>
        {content.map((item, index) => {
          return <li key={index}>{item}</li>
        })}
      </ul>
    </div>
  )
};

export default HowItWorksContent;
